import { render, staticRenderFns } from "./ExpireTime.vue?vue&type=template&id=5b69a1e4&"
import script from "./ExpireTime.vue?vue&type=script&lang=ts&"
export * from "./ExpireTime.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports